import CONQUER from "../../CONQUER";
import Awesome from "./Judgement";
import Stats from "./Stats";
import Judgement from  "./Judgement";
import { ACTIONS } from "../../../Models/ENUM";

class PostInstance
{
    private conquer     : CONQUER;

   // public Awesome      : Awesome;
   // public Stats        : Stats
    public postID       : any;
    public data         : any;
    public text         : any;
    public image        : any;
    public video        : any;
    public audio        : any;
    public title        : any;
    public replyToID    : any;
    public quoteID      : any;
    public avatarID     : any;

    public Avatar       : any;
    public type         : any;
    public isReply      : boolean = false;

    public views        : number = 0;

    public Judgement    : Judgement;

    public positive     : number = 0;
    public negative     : number = 0;

 
    constructor( conquer:CONQUER, data:any )
    {
        this.conquer    = conquer;

        this.fill( data );
   
        this.Judgement  = new Judgement( this.conquer, this );
 
       // this.Stats      = new Stats( conquer, this.postID );

        let self = this;

    }

    public fill( data:any )
    {
        this.data       = data;
        this.postID     = data._id;

        this.text       = data.text;
        this.image      = data.image;
        this.video      = data.video;
        this.title      = data.title;
        this.replyToID  = data.replyToID;
        this.quoteID    = data.quoteID;
        this.avatarID   = data.text;
        this.isReply    = data.isReply;

        this.positive   = data.positive;
        this.negative   = data.negative;
        
        /*
        
        this.Avatar 

        this.conquer.Avatars.load( this.avatarID, function( Avatar:any )
        {
            self.avatarID = Avatar;
        })
        */
    }

    public async refresh() : Promise<any>
    {
        let data = await this.conquer.do( ACTIONS.POST_GETONE, { _id:this.postID } ); 

        this.fill( data );

        return Promise.resolve();
    }

 
};

export default PostInstance;